import {Component, Input, OnInit} from '@angular/core';
import {CategoryListItem, CategoryService} from "../../../admin/products/categories/categories.service";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {TranslateService} from "@ngx-translate/core";
import {Product} from "../../../models/product";

@Component({
    selector: 'app-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.css'],
    providers: [CategoryService],
    standalone: false
})
export class NavHeaderComponent implements OnInit {

  @Input() product!: Product
  breadcrumbs: { label: string, url: string}[] = [];

  constructor(private router: Router, public categoryService: CategoryService, public translate:TranslateService,) {
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {

        });
  }

  updateBreadcrumbs(categories: CategoryListItem[]) {
    const cleanUrl = this.router.url.split(/[?#]/, 1)[0];
    const urlSegments = cleanUrl.split('/').filter(Boolean);
    let url = '';
    this.breadcrumbs = urlSegments.map((segment, index) => {
      url += '/' + segment;
      const cateKey = segment.replace(/-/g, ' ').toUpperCase()
      const crumbName = categories[cateKey]!= null? categories[cateKey].name : "N/A";
      return {
        label: this.capitalize(crumbName),
        url
      };
    });
    this.breadcrumbs = this.breadcrumbs.filter(crumb=> crumb.label != "N/A")
    // Optionally, add 'Home' at the start
    this.breadcrumbs.unshift({ label: this.translate.instant('sale4you.label.link.homePage'), url: '/' });
  }

  private capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  updateProductBreadcrumbs(product: Product){
    this.breadcrumbs.push({label: product.mainCategory.name, url:`/shop/${product.mainCategory.category.toLowerCase()}`})
    if(product.sconderyCategory?.name !=null){
      this.breadcrumbs.push({label: product.sconderyCategory.name, url:`/shop/${product.mainCategory.category.toLowerCase()}/category/${product.sconderyCategory.id}`})
    }
    this.breadcrumbs.push({label: '***', url:"/"})
    this.breadcrumbs.unshift({ label: this.translate.instant('sale4you.label.link.homePage'), url: '/' });
  }

  ngOnInit(): void {
    this.categoryService.getCategories().subscribe(categories => {
      if(this.product!= null){
          this.updateProductBreadcrumbs(this.product)
      }else{
        this.updateBreadcrumbs(categories);
      }
      // Use your categories here
    })
  }

}
